// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e_tT","delete":"styles_delete__1pvhh","update":"styles_update__34p3C","add":"styles_add__2yeOs"};